// Pure helpers for the /angebot quote form. Item codes mirror the backend
// allow-list (POST /api/quote-requests).
export const QUOTE_ITEMS = ["website", "google_profile", "local_seo", "structured_data", "reviews_setup", "ai_visibility", "other"];

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const EMPTY_QUOTE = { name: "", company: "", email: "", phone: "", scope: "full", items: [], message: "", consent: false };

// errors = t.quote.errors; returns { field: message } (empty object = valid).
export function validateQuote(v, errors) {
  const out = {};
  if (!v.name.trim()) out.name = errors.name;
  if (!v.company.trim()) out.company = errors.company;
  if (!EMAIL_RE.test(v.email.trim())) out.email = errors.email;
  if (v.scope === "items" && v.items.length === 0) out.items = errors.items;
  if (!v.consent) out.consent = errors.consent;
  return out;
}

export function buildQuotePayload(v, reportToken) {
  const payload = {
    name: v.name.trim(),
    company: v.company.trim(),
    email: v.email.trim(),
    scope: v.scope === "items" ? "items" : "full",
    items: v.scope === "items" ? v.items.filter((i) => QUOTE_ITEMS.includes(i)) : [],
    message: v.message.trim().slice(0, 4000),
    consent: true,
  };
  if (v.phone.trim()) payload.phone = v.phone.trim().slice(0, 50);
  if (reportToken) payload.report_token = String(reportToken).slice(0, 100);
  return payload;
}

export const toggleItem = (items, code) =>
  items.includes(code) ? items.filter((i) => i !== code) : [...items, code];
